import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ColumnFields } from '../../utils/dataTable/data';
import { RootState } from '../rootReducer';

export interface UserViewState {
  fields: ColumnFields;
}

const initialState: UserViewState = {
  fields: {}
};

const getUsersViewState = (state:RootState): UserViewState => state.adminDashboard.users;
const getUsersDashboardFields = (state: RootState): ColumnFields => getUsersViewState(state).fields;

export const selectors = {
  getUsersDashboardFields
};

const usersViewSlice = createSlice({
  name: 'usersViewAdminDashboard',
  initialState,
  reducers : {
    setUsersDashboardFields: (state: UserViewState, action: PayloadAction<ColumnFields>) => {
      state.fields = action.payload;
    }
  }
});

export const actions = { ...usersViewSlice.actions };
export default usersViewSlice.reducer;
